import { render, staticRenderFns } from "./UnitSubGroup.vue?vue&type=template&id=646a3f7b&"
import script from "./UnitSubGroup.vue?vue&type=script&lang=js&"
export * from "./UnitSubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports